import type { ColorItem } from 'webapp-types';

const DenimBlueHex = '#014077';
const VeryBlueHex = '#0575E6';

const BoardColorConfig: ColorItem[] = [
	{
		name: 'Orange',
		hex: '#DC5C0D',
		top: '#DC5D0E',
		bottom: '#9B261D',
		themes: [2, 4],
	},
	{
		name: 'Red',
		hex: '#C20B0F',
		top: '#C60708',
		bottom: '#A32B48',
		themes: [2, 4],
	},
	{
		name: 'Maroon red',
		hex: '#AF6161',
		top: '#B67171',
		bottom: '#6C2323',
		themes: [2, 3, 4],
	},
	{
		name: 'Burgundy red',
		hex: '#9E1233',
		top: '#AD2542',
		bottom: '#4A0E36',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'Magenta',
		hex: '#AC3566',
		top: '#B83666',
		bottom: '#512C6E',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'Orchid',
		hex: '#5E2B73',
		top: '#602B73',
		bottom: '#332872',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'Purple',
		hex: '#654278',
		top: '#6D4B81',
		bottom: '#371240',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'Modern purple',
		hex: '#564189',
		top: '#74539C',
		bottom: '#332574',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'Very blue',
		hex: VeryBlueHex,
		top: VeryBlueHex,
		bottom: '#021B79',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'Blue',
		hex: '#018EA3',
		top: '#0191A5',
		bottom: '#013E7A',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'Denim blue',
		hex: DenimBlueHex,
		top: '#014581',
		bottom: '#011D36',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'Deep sea',
		hex: '#2B3062',
		top: '#151F31',
		bottom: '#25253F',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'Dark turquoise',
		hex: '#118A9D',
		top: '#128B9E',
		bottom: '#013A3F',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'Stromboli green',
		hex: '#4C8A73',
		top: '#62A27B',
		bottom: '#144F5F',
		themes: [2, 4],
	},
	{
		name: 'Olive',
		hex: '#648327',
		top: '#6C8E24',
		bottom: '#586B34',
		themes: [2, 4],
	},
	{
		name: 'Pine green',
		hex: '#1D533B',
		top: '#4C7D36',
		bottom: '#013A3F',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'Coffee brown',
		hex: '#6A594F',
		top: '#766357',
		bottom: '#39312E',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'Slate grey',
		hex: '#697078',
		top: '#727981',
		bottom: '#151F31',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'Night blue',
		hex: '#20344C',
		top: '#253C56',
		bottom: '#2e3b3c',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'Grey',
		hex: '#212222',
		top: '#2A2B2B',
		bottom: '#141414',
		themes: [1, 2, 3, 4],
	},
	{
		name: 'White',
		hex: '#ffffff',
		top: '#ffffff',
		bottom: '#ffffff',
		themes: [1, 2, 3, 5],
		isLight: true,
	},
	{
		name: 'Sand',
		hex: '#FEF6E8',
		top: '#FDFBF5',
		bottom: '#FDF5E6',
		themes: [1, 2, 3, 5],
		isLight: true,
	},
	{
		name: 'Sky',
		hex: '#E4F2F8',
		top: '#FCFFFF',
		bottom: '#E4F2F8',
		themes: [1, 2, 3, 5],
		isLight: true,
	},
	{
		name: 'Dust',
		hex: '#EEF0F7',
		top: '#F5F5F5',
		bottom: '#E5F3FA',
		themes: [1, 2, 3, 5],
		isLight: true,
	},
];

export default BoardColorConfig;

export { DenimBlueHex as DefaultColor, VeryBlueHex as DefaultTeamColor };
